import { render, staticRenderFns } from "./Enseignants.vue?vue&type=template&id=40932994&"
import script from "./Enseignants.vue?vue&type=script&lang=js&"
export * from "./Enseignants.vue?vue&type=script&lang=js&"
import style0 from "./Enseignants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports